/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import {
  CommonMetadata,
  addOrUpdateCommonMetadata,
  generateIncrementedCommonCode,
} from '../../../../assets/ts/data/common-metadata'
import { filterRank, generateCode, scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import { ALL_SELECT_VALUE, SELECT_OPTION } from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputSelect from '../../../../utils/controls/input-select'
import InputText from '../../../../utils/controls/input-text'
import {
  AssignedComponent,
  Dropdown,
  IsArchived,
  Status,
} from '../../../../utils/controls/select-options-data'

interface Props {
  allRanks: string[]
  cancel: () => void
  editItems: any | null
  fetchCommonMetdata: () => void
  filtersvalue: any
  showAddPopup: boolean
  showEdit: any
  toggleView: () => void
}

interface RankValidations {
  Abbreviation: boolean
  Archived: boolean
  AssignedComponent: boolean
  Rank: boolean
  Status: boolean
  TitleMsg: string
}

const AddEditView = ({
  allRanks,
  cancel,
  editItems,
  fetchCommonMetdata,
  filtersvalue,
  showAddPopup,
  showEdit,
  toggleView,
}: Props) => {
  const { components, ranks } = useContext(MetadataContext)
  if (showAddPopup) {
    scrollToTop()
  }
  const [showAlert, setShowAlert] = useState(false)
  const selectValue = { label: 'Select', value: 'Select' }
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const [rankDDL, setRankDDL] = useState([selectValue])
  const [statusDDL, setStatusDDL] = useState([selectValue])
  const titleRef: any = useRef<any>(null)

  const [inputValues, setInputValues] = useState({
    Abbreviation: editItems?.abbreviation ? editItems.abbreviation : '',
    Archived: editItems?.archived ? editItems.archived : false,
    AssignedComponent: editItems?.assignedcomponent ? editItems.assignedcomponent : '',
    AssignedComponentCode: editItems?.assignedComponentCode
      ? editItems.assignedComponentCode
      : ALL_SELECT_VALUE,
    Rank: editItems?.rank ? editItems.rank : '',
    Status: editItems?.status ? editItems.status : '',
  })

  const [rankValidations, setRankValidations] = useState<RankValidations>({
    Abbreviation: false,
    Archived: false,
    AssignedComponent: false,
    Rank: false,
    Status: false,
    TitleMsg: '',
  })
  const onClickAlert = async () => {
    setShowAlert(false)
  }

  useEffect(() => {
    const titleElemnt = document.getElementById('Rank')
    if (titleRef?.current && titleElemnt) {
      titleRef?.current?.scrollIntoView(false)
      titleElemnt.focus()
    }
  }, [titleRef, showEdit])
  const saveRank = async () => {
    const userDetails = await mpfRListsHttp().me()
    setShowPageOverlay(true)
    const newCode = await generateIncrementedCommonCode()
    const userId = userDetails.userId
    const currentDate = new Date()

    const addUpdateObj: Partial<CommonMetadata> = {
      AdditionalValue3: inputValues.Status,
      AllowEdit: true,
      Code: editItems ? editItems.code : newCode,
      IsArchived: inputValues.Archived ? inputValues.Archived : false,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      MetadataDescription: '',
      MetadataType: 'Rank',
      MetadataValue: inputValues.Rank,
      OrgComponent: 'HAF', //may need to be updated dynamcially
      OrgLevel1: 'ALL',
      OrgLevel2: 'ALL',
      ParentCode: generateCode(inputValues.AssignedComponentCode),
      ShortName: inputValues.Abbreviation,
      eKey: editItems ? editItems.eKey : '',
      eTag: editItems ? editItems.eTag : '',
    }
    let isNoChangesDetected = false
    if (inputValues.Rank === editItems?.rank &&
      inputValues.Abbreviation === editItems?.abbreviation &&
      inputValues.Archived === editItems?.archived &&
      inputValues.AssignedComponent === editItems?.assignedcomponent &&
      inputValues.Status === editItems?.status
    ) {
      isNoChangesDetected = true
      setShowAlert(true)
    }

    if (!isNoChangesDetected) {
      try {
        await addOrUpdateCommonMetadata(addUpdateObj)
        setShowPageOverlay(false)
        cancel()
      } catch (error) {
        console.error(error)
        cancel()
        setShowPageOverlay(false)
      }
    } else {
      setShowPageOverlay(false)
    }
  }

  const handleSubmit = async () => {
    let isValid = true
    const validations: RankValidations = {
      Abbreviation: false,
      Archived: false,
      AssignedComponent: false,
      Rank: false,
      Status: false,
      TitleMsg: '',
    }

    if (inputValues.Rank === '') {
      isValid = false
      validations.Rank = true
    }
    if (
      inputValues.Rank !== '' &&
      allRanks?.find(
        (rank) => editItems?.rank?.toLowerCase() !== inputValues?.Rank?.toLowerCase() &&
        inputValues?.Rank?.toLowerCase() === rank.toLowerCase())
    ) {
      isValid = false
      validations.Rank = true
      validations.TitleMsg = 'This rank already exist. Please enter unique rank name.'
    }
    if (inputValues.AssignedComponentCode === -1) {
      isValid = false
      validations.AssignedComponent = true
    }
    if (inputValues.Abbreviation === '') {
      isValid = false
      validations.Abbreviation = true
    }
    if (inputValues.Status === '' || inputValues.Status === SELECT_OPTION.label) {
      isValid = false
      validations.Status = true
    }
    //add rest of validations
    setRankValidations(validations)
    if (isValid) {
      await saveRank()
      await fetchCommonMetdata()
      //reset input values here
      toggleView()
    }
  }

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }
  const changeAssignedComponent = (e: { label: string; value: number }) => {
    handleChange('AssignedComponent', e.label)
    handleChange('AssignedComponentCode', e.value)
  }

  const changeStatus = (e: any) => {
    const includeSelect = [selectValue]
    const { value } = e
    const filteredRank = filterRank(value, ranks, inputValues.AssignedComponentCode)
    const rankOption =
      filteredRank.length === 1 ? filteredRank : [...includeSelect, ...filteredRank]
    setRankDDL(rankOption)
    setInputValues({
      ...inputValues,
      Status: value,
    })
  }

  const changeArchived = (e: { label: string; value: string }) => {
    handleChange('Archived', e.value)
  }

  const componentOptions: Dropdown[] = [
    SELECT_OPTION,
    ...components.map((c) => ({
      label: c.Component,
      value: c.ComponentCode,
    })),
  ]

  useEffect(() => {
    const includeSelect = [selectValue]
    const profileStatusDDL = [
      ...new Set(
        ranks
          ?.filter((assCom) => assCom.AssignedComponentCode === inputValues.AssignedComponentCode)
          .map(({ Status }) => {
            return Status
          })
      ),
    ].map((rank) => {
      return { label: rank, value: rank }
    })
    const ddl = [...includeSelect, ...profileStatusDDL]
    setStatusDDL(ddl)
  }, [ranks, inputValues.AssignedComponentCode])

  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label='Add Rank'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Rank
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div
            className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}
            ref={titleRef}
          >
            <InputText
              changeHandler={(e: any) => handleChange('Rank', e.target.value)}
              error={rankValidations?.Rank}
              formClassName='d-flex flex-column'
              info='Rank'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Rank',
                name: ' Rank',
                placeholder: 'Enter Rank',
                value: inputValues?.Rank,
              }}
              isInfo
              isMandatory
              label='Rank'
              uniqueErrormsg={rankValidations?.TitleMsg}
              value={inputValues?.Rank}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <InputText
              changeHandler={(e: any) => handleChange('Abbreviation', e.target.value)}
              error={rankValidations?.Abbreviation}
              formClassName='d-flex flex-column'
              info='Abbreviation'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Abbreviation ',
                name: ' Abbreviation',
                placeholder: 'Enter Abbreviation',
                value: inputValues?.Abbreviation,
              }}
              isInfo
              isMandatory
              label='Abbreviation'
              value={inputValues?.Abbreviation}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={rankValidations?.AssignedComponent}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
                options: componentOptions,
                value: inputValues?.AssignedComponentCode,
              }}
              isInfo
              isMandatory
              label='Assigned Component'
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={componentOptions}
              value={inputValues?.AssignedComponentCode}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={rankValidations?.Status}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Status'
              info='Status '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
                value: inputValues?.Status,
              }}
              isInfo
              isMandatory
              label='Status'
              menuPosition={'fixed'}
              name='Status'
              onChange={changeStatus}
              options={statusDDL}
              value={inputValues?.Status}
            />
          </div>
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                isMandatory
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={changeArchived}
                options={IsArchived}
                value={inputValues?.Archived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
